import Slider from 'react-slick';
import styled from 'styled-components';

const Carousel = styled(Slider)<{ gap?: string }>`
  .slick-loading .slick-list {
    background: #fff url('./ajax-loader.gif') center center no-repeat;
  }

  /* Arrows */
  .slick-prev,
  .slick-next {
    position: absolute;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
  }
  .slick-prev.slick-disabled::before,
  .slick-next.slick-disabled::before {
    opacity: 0.25;
  }

  .slick-prev {
    left: -15px;
    z-index: 1;
  }
  [dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
  }
  .slick-next {
    right: -15px;
  }
  [dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  ul.slick-dots {
    ${({ theme }) => theme.media.lgBelow} {
      display: none !important;
    }
  }
  .slick-dots {
    width: 100%;
    padding: 0;
    margin: 12px 0 0;
    list-style: none;
    text-align: right;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
  }

  .slick-dots li {
    position: relative;
    display: inline-block;
    margin: 0 5px;
    padding: 0 15px;
    cursor: pointer;
    padding-top: 12px;
  }

  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }

  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }

  .slick-dots li button:hover::before,
  .slick-dots li button:focus::before {
    opacity: 1;
    background: ${({ theme }) => theme.colors.accent};
  }

  .slick-dots li button::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 45px;
    height: 6px;
    content: '';
    text-align: center;
    opacity: 0.25;
    background: ${({ theme }) => theme.colors.fillBlack};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-dots li.slick-active button::before {
    opacity: 1;
    background: ${({ theme }) => theme.colors.accent};
  }

  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: auto;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;

  .slick-list {
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: none;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-track,
  .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    margin: auto;
  }
  .slick-track::before,
  .slick-track::after {
    display: table;
    content: '';
  }
  .slick-track::after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }
  .slick-slide {
    display: none;
    float: left;
    min-height: 1px;
    ${({ gap }) => gap && `padding: ${gap};`}
  }
  .slick-slide > div {
    height: 100%;
  }

  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }
`;

export default Carousel;
